import { Component } from '@angular/core';

@Component({
  selector: 'hbo-scan-errors',
  templateUrl: './scan-errors.component.html',
  styleUrls: ['./scan-errors.component.scss']
})
export class ScanErrorsComponent {

}
